(function () {
  Flint.file('mframework/views/linkButton.js', function (require) {
    Flint.view('LinkButton', function (view, on, $) {
      var pro = initPro(view, {
        children: atom(),
        style: M.defaultAtom({})
      });view.render(function () {
        return view.el(
          ['linkButton', 1],
          {
            style: IMap({
              cursor: 'pointer',
              color: 'black'
            }).merge(pro.style.get()).toJS(),
            onClick: view.props.onClick
          },
          pro.children.get()
        );
      });
    });
  })
})();
//# sourceMappingURL=linkButton.js.map
